// Controlled video indexing pilot.
// Cohort 1: 10 URLs from the 2026-06-06 GSC Pages export.
// Cohort 2: 5 URLs linked from the indexed fitness-influencers article and
// 5 URLs linked from the 2026-08-17 through 2026-08-23 Content Review.
export const INDEXABLE_VIDEO_PILOT_SLUGS = new Set([
  '9641-chic-friend-archetype-observation',
  '14275-explaining-a-3x-daily-posting-strategy',
  '15368-aesthetic-blush-texture-showcase-video',
  '10709-solo-cafe-date-with-mindset-text',
  '11270-baking-sour-patch-kids-casserole',
  '12394-chicken-parmesan-recipe-and-preparation',
  '12782-opinionated-list-of-gift-spending-limits',
  '3937-documenting-a-political-protest-confront',
  '13811-creator-reviews-interactive-3d-website',
  '17850-creative-pickle-house-art-showcase',
  '20565-low-calorie-diet-hack-review',
  '14391-chinese-longevity-exercise-routine-showc',
  '34542-aggressive-motivational-speech-while-run',
  '10919-dreadlocks-swim-cap-expectation-vs-reali',
  '20713-week-by-week-gym-return-playbook',
  '39348-workplace-wish-goes-horribly-wrong',
  '39528-satirical-corporate-jargon-job-interview',
  '39505-problem-solution-story-for-dorm-product',
  '39273-science-behind-oil-poached-fish',
  '39745-one-year-house-build-journey'
]);

export function isIndexableVideoPilot(path) {
  const match = String(path || '').match(/^\/video\/([^/?#]+)$/);
  return Boolean(match && INDEXABLE_VIDEO_PILOT_SLUGS.has(match[1]));
}
